import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SummaryRoutingModule} from './summary-routing.module';
import {SummaryComponent} from './summary.component';
import {PipeModule} from '../shared/pipes/pipe.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PipeModule,
    SummaryRoutingModule
  ],
  declarations: [
    SummaryComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class SummaryModule { }



// WEBPACK FOOTER //
// ./src/app/summary/summary.module.ts